import { ReferenceInput, SelectInput } from "react-admin";
import * as React from "react";
import { SourceAircraftType } from "../../../Pages/Admin/AircraftType";

const AircraftTypeInput = props => {
  return (
    <ReferenceInput
      label="Aircraft Type"
      source="aircraftTypeId"
      reference={SourceAircraftType}
      translateChoice={false}
      {...props}
    >
      <SelectInput optionText="aircraftTypeCode" optionValue="id" />
    </ReferenceInput>
  );
};

export default AircraftTypeInput;
